import { SortOptions } from '@/shared/types/common';

export const modulesSortOptions: SortOptions[] = [
  {
    id: '1',
    title: 'Progress',
    options: [
      { label: 'High to Low', value: 'progressPercent:desc' },
      { label: 'Low to High', value: 'progressPercent:asc' },
    ],
  },
  {
    id: '2',
    title: 'Attendance',
    options: [
      { label: 'High to Low', value: 'attendancePercent:desc' },
      { label: 'Low to High', value: 'attendancePercent:asc' },
    ],
  },
  {
    id: '3',
    title: 'Title',
    options: [
      { label: 'A-Z', value: 'title:asc' },
      { label: 'Z-A', value: 'title:desc' },
    ],
  },
];

export const studentsSortOptions: SortOptions[] = [
  {
    id: '1',
    title: 'Progress',
    options: [
      { label: 'High to Low', value: 'progressByLessons:desc' },
      { label: 'Low to High', value: 'progressByLessons:asc' },
    ],
  },
  {
    id: '2',
    title: 'Attendance',
    options: [
      { label: 'High to Low', value: 'attendance:desc' },
      { label: 'Low to High', value: 'attendance:asc' },
    ],
  },
  {
    id: '3',
    title: 'Last Activity',
    options: [
      { label: 'Newest', value: 'lastActivity:desc' },
      { label: 'Oldest', value: 'lastActivity:asc' },
    ],
  },
  {
    id: '4',
    title: 'Registration Date',
    options: [
      { label: 'Newest', value: 'registrationDate:desc' },
      { label: 'Oldest', value: 'registrationDate:asc' },
    ],
  },
];

